import { ModuleLargeAssetAndGridFragment } from '@/graphql';
import { FC } from 'react';
import LargeAssetAndGrid from '@/components/_organisms/LargeAssetAndGrid';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';

interface FeatureGroupsModuleProps {
  props: CraftModuleFragment<ModuleLargeAssetAndGridFragment>;
}

const LargeAssetAndGridModule: FC<FeatureGroupsModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const asset = getSingle(props.asset);

  let videoSrc: string | undefined;

  if (asset?.mimeType?.startsWith('video/') && asset?.url) {
    videoSrc = asset.url;
  }

  return (
    <LargeAssetAndGrid
      heading={props.heading ?? undefined}
      image={
        asset?.url && !videoSrc
          ? {
              src: asset.url,
              width: asset.width ?? 0,
              height: asset.height ?? 0,
              alt: '',
            }
          : undefined
      }
      videoSrc={videoSrc}
      items={
        props.gridItems?.filter(notEmpty).map((item) => ({
          title: item.title ?? '',
          description: item.description ?? '',
        })) ?? []
      }
    />
  );
};

export default LargeAssetAndGridModule;
